const rutasProyectoTorre1 = [

  // torre_1
  // torre_1_p1
  // torre_1_pisos
  // torre_1_ventanas
  // torre_1_balconesMuros
  // torre_1_balconesBarandas * tiene Alpha

  /// Modelos
  {
    name: "modelo_torre_1",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 01_FL.gltf",
  },
  {
    name: "modelo_torre_1_p1",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 01_P1_FL.gltf",
  },
  {
    name: "modelo_torre_1_pisos",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 01_PISOS Y CUARTOS CUBIERTA_FL.gltf",
  },
  {
    name: "modelo_torre_1_ventanas",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 01_VENTANAS_FL.gltf",
  },
  {
    name: "modelo_torre_1_balconesMuros",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 01_BALCONES_MUROS_FL.gltf",
  },
  {
    name: "modelo_torre_1_balconesBarandas",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 01_BALCONES_BARANDAS_FL.gltf",
  },

  ///Texturas  
  /*{
    name: "text_ejemplo",
    type: "texture",
    path: "texturas/proyecto/ejemplo.webp"
  },*/

  {
    name: "text_torre_1",
    type: "texture",
    path: "texturas/proyecto/TORRE 01_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_p1",
    type: "texture",
    path: "texturas/proyecto/TORRE 01_P1_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_pisos",
    type: "texture",
    path: "texturas/proyecto/TORRE 01_PISOS Y CUARTOS CUBIERTA_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_ventanas",
    type: "texture",
    path: "texturas/proyecto/TORRE 01_VENTANAS_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_balconesMuros",
    type: "texture",
    path: "texturas/proyecto/TORRE 01_BALCONES_MUROS_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_balconesBarandas",
    type: "texture",
    path: "texturas/proyecto/TORRE 01_BALCONES_BARANDAS_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_balconesBarandas_alpha",
    type: "texture",
    path: "texturas/proyecto/TORRE 01_BALCONES_BARANDAS_FL_Corona_Alpha.webp"
  },
];

export default rutasProyectoTorre1;
